
// Technical/hard skills (mix of IT and non-IT)
export const hardSkills = [
  // Technical skills
  "JavaScript",
  "TypeScript",
  "React.js",
  "Node.js",
  "Python",
  "Java",
  "C#",
  "PHP",
  "Angular",
  "Vue.js",
  "SQL",
  "MongoDB",
  // DevOps skills
  "AWS",
  "Docker",
  "Kubernetes",
  "CI/CD",
  "Git",
  "PostgreSQL",
  "Redis",
  "MySQL",
  "DevOps",
  "Linux",
  "Cloud Computing",
  "Terraform",
  // Non-IT hard skills
  "Financial Analysis",
  "Accounting",
  "Digital Marketing",
  "SEO",
  "Content Writing",
  "Copywriting",
  "Market Research",
  "Data Analysis",
  "Statistical Analysis",
  "Graphic Design",
  "Video Editing",
  "Photography",
  "Adobe Photoshop",
  "Google Analytics",
  "Project Management",
  "Business Analysis",
  "Quality Assurance",
  "R Programming",
  "Figma",
  "Adobe XD",
  "Product Management",
  "UX Research",
  "UI Design"
];

// Soft skills and competencies
export const softSkills = [
  "Communication",
  "Teamwork",
  "Problem Solving",
  "Critical Thinking",
  "Time Management",
  "Leadership",
  "Adaptability",
  "Creativity",
  "Attention to Detail",
  "Conflict Resolution",
  "Decision Making",
  "Emotional Intelligence",
  "Negotiation",
  "Public Speaking",
  "Active Listening",
  "Mentoring",
  "Customer Service",
  "Strategic Planning",
  "Work Ethic",
  "Collaboration",
  "Flexibility",
  "Patience",
  "Self-Motivation",
  "Stress Management",
  "Empathy",
  "Cultural Awareness",
  "Persuasion",
  "Networking",
  "Coaching",
  "Sales",
  "Agile",
  "Scrum",
  "Analytical Thinking",
  "Presentation Skills",
  "Interpersonal Skills"
];

// Combine all skills and sort them
export const allSkills = [...hardSkills, ...softSkills].sort();

// Function to get skill type (useful for UI display)
export const getSkillType = (skill: string): "hard" | "soft" | "custom" => {
  if (hardSkills.includes(skill)) return "hard";
  if (softSkills.includes(skill)) return "soft";
  return "custom";
};
